import { apiClient } from './client';

export type ConfigScope = 'SYSTEM' | 'TENANT' | 'RANCHO' | 'LOTE';

export interface ResolvedConfigValue {
  key: string;
  value: unknown;
  source: ConfigScope | 'DEFAULT';
  sourceId?: string;
}

export interface ConfigSettingMeta {
  key: string;
  type: 'boolean' | 'number' | 'string' | 'enum' | 'range';
  default: unknown;
  minScope: ConfigScope;
  maxScope: ConfigScope;
  editableBy: string;
  options?: readonly string[];
  min?: number;
  max?: number;
  description: { es: string; en: string; zh: string };
}

export interface ScopedConfigResponse {
  scope: ConfigScope;
  scopeId: string;
  own: Record<string, unknown>;
  effective: Record<string, ResolvedConfigValue>;
  catalog: ConfigSettingMeta[];
}

/** GET /api/:tenantId/config/:scope/:scopeId — valores propios + efectivos con herencia. */
export const fetchScopedConfig = async (scope: ConfigScope, scopeId: string): Promise<ScopedConfigResponse> =>
  (await apiClient.get(`/api/config/${scope}/${scopeId}`)).data;

/** PUT /api/:tenantId/config/:scope/:scopeId — escribe settings en ESE nivel. */
export const putScopedConfig = async (
  scope: ConfigScope,
  scopeId: string,
  settings: Record<string, unknown>,
): Promise<{ scope: ConfigScope; scopeId: string; updated: string[] }> =>
  (await apiClient.put(`/api/config/${scope}/${scopeId}`, { settings })).data;

export const fetchConfigCatalog = async (): Promise<{ catalog: ConfigSettingMeta[]; scopes: ConfigScope[] }> =>
  (await apiClient.get('/api/config/catalog')).data;
